export const TOTAL_MARKET=1;
export const  MAN_RANK=2;
export const  CATEGORY_MARKET=3;
export const  COUNTRY_MARKET=4;
export const  SEGMENT_MARKET=5;
export const  FUEL_MARKET=6;